import {
	GetAdminFaqManualsQuery,
	GetAdminNavigationQuery,
	GetAdminSettingsQuery,
	GetAllLanguageSetsQuery,
	GetFaqCategoriesQuery,
	GetFaqEntriesQuery,
	GetLanguagesQuery,
	GetSettingsQuery,
} from "__generated__/view/admin/graphql/admin.queries.generated";
import { ChildProps, ChildPropsFromArray } from "types/commons";

export enum AdminTab {
	Settings = "settings",
	Trigger = "trigger",
	Language = "language",
	Navigation = "navigation",
	Support = "support"
}

export enum AdminLanguageTab {
	LanguageKeys = "languageKeys",
	ManangeLanguages = "manageLanguages"
}

export enum PluginType {
	Boolean = 1,
	String = 2,
	Number = 3,
	Select = 4,
	Double = 5,
	MultiValue = 6
}

export type Settings = ChildProps<GetSettingsQuery, "settings">;
export type AdminSettings = ChildProps<GetAdminSettingsQuery, "adminSettings">;
export type AdminSettingsPlugin = ChildPropsFromArray<AdminSettings, "plugins">;
export type AdminSettingsPluginValue = AdminSettingsPlugin["value"] | number | boolean;
export type AdminSettingsGroup = ChildPropsFromArray<AdminSettings, "fields">;
export type AdminSettingsGroupField = ChildPropsFromArray<AdminSettingsGroup, "fields">

export type AdminLanguage = ChildPropsFromArray<GetLanguagesQuery, "languages">;
export type AdminLanguageSet = ChildPropsFromArray<GetAllLanguageSetsQuery, "languageSets">;
export type AdminLanguageSetTranslation = ChildPropsFromArray<AdminLanguageSet, "translations">["translation"];

export type CustomTranslationEntry = {
	id: number;
	key: string;
	translations: Record<string, string>;
}

export type CustomerTranslations = {
	entries: Record<string, Record<string, string>>;
}

export type AdminSupportCategory = ChildPropsFromArray<GetFaqCategoriesQuery, "faqCategories">;
export type AdminSupportEntry = ChildPropsFromArray<GetFaqEntriesQuery, "faqEntries">;
export type AdminSupportManual = ChildPropsFromArray<GetAdminFaqManualsQuery, "adminFaqManuals">;

export type AdminNavigationItem = {
	uniqueId?: string;
} & Omit<ChildPropsFromArray<GetAdminNavigationQuery, "adminNavigation">, "children"> & {
	children?: Omit<AdminNavigationItem, "children">[];
};
